"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const VideoCameraIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsx)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 14 10", width: size, ...rest, children: (0, jsx_runtime_1.jsx)("path", { d: "M10.6095 0.723898C10.8596 0.973947 11 1.31309 11 1.66671V3.88871L13.6667 1.66671V8.33337L11 6.11137V8.33337C11 8.687 10.8596 9.02613 10.6095 9.27618C10.3595 9.52623 10.0203 9.66671 9.66671 9.66671H1.66671C1.31309 9.66671 0.973947 9.52623 0.723898 9.27618C0.47385 9.02613 0.333374 8.687 0.333374 8.33337V1.66671C0.333374 1.31309 0.47385 0.973947 0.723898 0.723898C0.973947 0.47385 1.31309 0.333374 1.66671 0.333374H9.66671C10.0203 0.333374 10.3595 0.47385 10.6095 0.723898Z" }) }));
exports.default = (0, IconContainer_1.default)(VideoCameraIcon);
//# sourceMappingURL=index.js.map